import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import AuthModal from '../auth/AuthModal';
import { ErrorBoundary } from '../common/ErrorBoundary';

const Layout: React.FC = () => (
  <div className="flex flex-col min-h-screen">
    <Header />
    <main className="flex-1 container mx-auto px-4 py-8 max-w-screen-2xl">
      <ErrorBoundary>
        <Outlet />
      </ErrorBoundary>
    </main>
    <Footer />
    <AuthModal />
  </div>
);

export default Layout;
